import React, { FC } from "react";
import { navigate } from "gatsby";
import { NavigationMenu, NavigationMenuItem, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { normalizePath } from "@/utility";

interface MobileMenuProps {
  onClose: () => void;
  open: boolean;
  navigationMenu: { link: string; caption: string }[];
  path: string;
  myPriceList: {
    id: string;
    quantity: number;
  }[];
}

const MobileMenu: FC<MobileMenuProps> = ({
  onClose,
  navigationMenu,
  path,
  myPriceList,
}) => {
  const createMenuClickHandler = (link: string) => () => {
    navigate(link);
    onClose();
  };

  console.log('myPriceList in MobileMenu:', myPriceList);

  return (
    <NavigationMenu className="max-w-none">
      <NavigationMenuList className="flex-col items-start gap-1">
        {navigationMenu.map((menuItem) => {
          const showBadge = menuItem.link == '/my-products';
          return (
            <NavigationMenuItem key={menuItem.link} className="w-full relative">
              <button
                onClick={createMenuClickHandler(menuItem.link)}
                className={cn(
                  'w-full px-3 py-2 text-sm text-left font-medium transition-colors hover:bg-accent hover:text-accent-foreground cursor-pointer no-underline font-krub uppercase [text-shadow:_0px_4px_4px_rgba(27,69,33,0.25)] text-white leading-4',
                  { 'bg-black/10': normalizePath(path).includes(normalizePath(menuItem.link)) }
                )}
              >
                {menuItem.caption}
                {showBadge && (
                  <Badge className={'ml-2 bg-textAccent top-3 -right-3'}>
                    {myPriceList.length}
                  </Badge>
                )}
              </button>
            </NavigationMenuItem>
          );
        })}
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default MobileMenu;
